module.exports = __webpack_public_path__ + "img/logo_nikkei.51618b4b.png";